import React from 'react';
import P, { InferProps } from 'prop-types';
import { useStringsContext } from '../../../contexts/strings';
import { useTeamData } from '../../common/team';
import Header from '../../common/team/header';
import Category from '../../common/team/category';
import { Box, Typography } from '@mui/material';
import ScenePage from '../../common/scene/scene-page';

function AppArena({ match }: InferProps<typeof AppArena.propTypes>) {
  const teamAbbrv = match.params.id;
  const { strings } = useStringsContext();
  const {
    categories,
    teamDocError,
    appConfigDocError,
    teamDocLoading,
    appConfigDocLoading,
    onSubmit,
    isValid,
    isReadOnly,
    isDirty,
    isSubmitting,
    isSuperAdmin,
    setChange,
    handleValidation,
  } = useTeamData(teamAbbrv);

  const pageCategories = categories.filter((category) => ['Arena'].includes(category.name));

  return (
    <ScenePage title={strings.appBar.arena}>
      {teamDocError || appConfigDocError ? (
        <p>{teamDocError?.message || appConfigDocError?.message}</p>
      ) : (
        <>
          {!teamDocLoading && !appConfigDocLoading && (
            <>
              <Header
                onSubmit={onSubmit}
                isSubmitting={isSubmitting}
                isDisabled={!isValid || !!isReadOnly || !isDirty}
                title={strings.appBar.arena}
                border
              />
              <Box sx={{ mt: 4 }}>
                {pageCategories.map((category) => (
                  <Box key={category.name} sx={{ mb: 5 }}>
                    {pageCategories.length > 1 ? (
                      <Typography variant="h6" sx={{ mb: 4, fontWeight: 400, ml: 3 }}>
                        {category.title}
                      </Typography>
                    ) : null}
                    <Category
                      teamAbbrv={teamAbbrv}
                      category={category}
                      path={teamAbbrv}
                      setChange={setChange}
                      setValidation={handleValidation}
                      isSuperAdmin={isSuperAdmin}
                    />
                  </Box>
                ))}
              </Box>
            </>
          )}
        </>
      )}
    </ScenePage>
  );
}

AppArena.propTypes = {
  match: P.shape({
    params: P.shape({
      id: P.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default AppArena;
